import React from "react";
import ConfigSection from "../../ConfigSection";

const NoticePeriodSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Notice Period'
      configType='NoticePeriod'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default NoticePeriodSection;
